module.exports = __webpack_public_path__ + "media/images/builder/majaslapa2-89942ee8a05682b3b2b45fc65b38a744.png";